/**
 * Abbi Theme type scale (SF Pro, iOS pt). Plain size / line-height / weight values;
 * RN Text scales with Dynamic Type by default (`allowFontScaling`), and existing
 * `maxFontSizeMultiplier` caps on dense layouts still apply. Minimum anywhere: 12pt.
 * Native mobile screens only for now; web admin keeps its own sizes.
 */
export const typeScale = {
    /** Screen large title ("Today"). */
    title: { fontSize: 34, lineHeight: 41, fontWeight: '700' },
    /** Pushed screen header ("Meal Map"). */
    navTitle: { fontSize: 18, lineHeight: 23, fontWeight: '600' },
    /** Section labels ("Daily check-in", "Meals"). */
    section: { fontSize: 22, lineHeight: 28, fontWeight: '700' },
    rowTitle: { fontSize: 20, lineHeight: 25, fontWeight: '600' },
    /** Row subtitles, banner body. */
    subtitle: { fontSize: 15, lineHeight: 20, fontWeight: '400' },
    /** Date line, card labels; use `captionStrong` for overlines. */
    caption: { fontSize: 14, lineHeight: 19, fontWeight: '400' },
    captionStrong: { fontSize: 14, lineHeight: 19, fontWeight: '600' },
    tabLabel: { fontSize: 12, lineHeight: 16, fontWeight: '600' },
    button: { fontSize: 17, lineHeight: 22, fontWeight: '600' },
};
